export const BANNER_CLOSE_COOKIE_VALUE = '1';

export const DEFAULT_COOKIE_VALUE = '1';

export const DEFAULT_COOKIE_EXPIRATION_DURATION = 86400;
